
import {  EDIT_COMPANY_INFO_ERROR, EDIT_COMPANY_INFO_POST_ERROR, EDIT_COMPANY_INFO_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    edited:{},
    success:false,
    key:null
}, action) => {
    switch (action.type) {
        case EDIT_COMPANY_INFO_ERROR:
            return {
                ...state,
                error: action.payload,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                key:action.key,
                ErrorMessage: action.payload.message,
            };
            break; 
            case EDIT_COMPANY_INFO_SUCCESS:
                return {
                    ...state,
                    error: action.payload,
                    loading:false, 
                    success:true,
                    edited:action.payload,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    key:action.key,
                    ErrorMessage: 'Company Edited Successfully',
                };
                break;
            
        case EDIT_COMPANY_INFO_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                key:action.key,
                ErrorMessage: 'Edit Company Error | ' + state.error,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/editCompanyReducer.js